export default __webpack_public_path__ + "static/media/reported.819eb2c0.svg";